import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Button, Container } from "react-bootstrap";
import Rating from "@mui/material/Rating";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import axios from "axios";
import { base_url, ImageUrl, postHeader } from "../../../../../Helpers/request";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Heading from "../ui/Heading";
import { isDesktop, isMobile } from "react-device-detect";
import { id } from "date-fns/locale";

const Customer = () => {
  // const [customerData, setCustomerData] = useState([]);

  // const GetCustomerRewies = useCallback(() => {
  //   axios
  //     .get(`${base_url}/common/site_reviews`, { headers: postHeader })
  //     .then(({ data }) => {
  //       if (data.status === 1) {
  //         setCustomerData(data.data);
  //       }
  //     })
  //     .catch((error) => console.error("Error fetching reviews:", error));
  // }, []);

  // useEffect(() => {
  //   GetCustomerRewies();
  // }, [GetCustomerRewies]);

  // 🔥 Fix `aria-hidden` and `tabindex`
  const updateTabIndex = () => {
    setTimeout(() => {
      document.querySelectorAll(".slick-slide").forEach((slide) => {
        const isHidden = slide.getAttribute("aria-hidden") === "true";
        console.log(`Slide ${slide.getAttribute("data-index")} hidden:`, isHidden); // Debugging Log

        slide.querySelectorAll("a, button, input").forEach((el) => {
          if (isHidden) {
            el.setAttribute("tabindex", "-1");
          } else {
            el.removeAttribute("tabindex");
          }
        });
      });
    }, 100);
  };

  const settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow: <LazyLoadImage src={`${ImageUrl}theme/showcase/left.png`} alt="arrow" />,
    nextArrow: <LazyLoadImage src={`${ImageUrl}theme/showcase/right.png`} alt="arrow" />,
    responsive: [
      { breakpoint: 1479, settings: { slidesToShow: 4, dots: true, arrows: false } },
      { breakpoint: 1025, settings: { slidesToShow: 2, dots: true, arrows: false } },
      { breakpoint: 600, settings: { slidesToShow: 1, dots: true, arrows: false } },
    ],
    afterChange: updateTabIndex, // 🔥 Fix tabbing issue
  };

  // useEffect(() => {
  //   updateTabIndex();
  // }, [customerData]);

  const customerData = [  
    {
      id: 1,
      username: "Elena Karavassilis",
      review:"My family has been customers of Elliot’s for many years and every single transaction has been nothing but amazing! Elliot is a genuine person, he always provides his honest, professional opinion,",
      rating: 5

    },
    {
      id: 1,
      username: "Elliot Galpern",
      review:"Elliot was amazing. Aside from us sharing a name, he was extremely personable, generous with his time, was not pushy at all. I could not have asked for more. ",
      rating: 5

    },
    {
      id: 1,
      username: "Rory Sasson",
      review:"Elliot provides exceptional service and is extremely honest and professional. He was tremendously helpful to me when looking for a necklace and was so easy to work with every step of the way. ",
      rating: 5

    },
    {
      id: 1,
      username: "Ollie Lutton",
      review:"I went in not knowing what I was doing, with zero knowledge about diamonds and even if I wanted to purchase anything.",
      rating: 5

    },
    {
      id: 1,
      username: "Erica Acheychek",
      review:"I highly recommend Eli David Designs! Elliot was amazing to work with! He completely understood my vision and put together the most gorgeous diamond necklace for me.",
      rating: 5
    }
  ]
  return (
    <section className="rcs_customer_say_section">
      <Container fluid className="showcase-container">
        <div className="d-flex align-items-center justify-content-between pb-3">
          <Heading className="text-left p-0">
            <h2>Happy Customers</h2>
            <p>Words of Praise</p>
          </Heading>
          {isDesktop && (
            <div className="rcs_customer_review_btn">
              <Button className="btn outline-base-btn large" onClick={() => window.open("https://www.google.com/search?sca_esv=e45feeb30c95b33e&q=Eli+David+Designs&ludocid=4067783767724045677&lsig=AB86z5WmpIlGOup3PfemKu7soR6i&sa=X&ved=2ahUKEwjpzZqf6cqMAxURja8BHf5BKqUQoAJ6BAghEBo&biw=1745&bih=828&dpr=1.1#lrd=0x89c259352c0429df:0x3873abc8e24ab56d,1,,,,", "_blank")}>
                Write a Review
              </Button>
            </div>
          )}
        </div>

        <Row>
          <Col lg={12} data-aos="fade-up" data-aos-duration="1400">
            <div className="rcs_customer_review_slider">
              <Slider className="rcs_customer_say_inner" {...settings2}>
                {customerData.map((customdata, index) => (
                  <div className="rcs_customer_review_slide_item" key={index}>
                    <div className="rcs_customer_slide_title_img mb-4">
                      <div className="rcs_customer_review_slide_img">
                        <LazyLoadImage
                          src={`${ImageUrl}theme/showcase/review.png`}
                          alt="Google Review Image"
                          onClick={() => window.open("https://www.google.com/search?sca_esv=e45feeb30c95b33e&q=Eli+David+Designs&ludocid=4067783767724045677&lsig=AB86z5WmpIlGOup3PfemKu7soR6i&sa=X&ved=2ahUKEwjpzZqf6cqMAxURja8BHf5BKqUQoAJ6BAghEBo&biw=1745&bih=828&dpr=1.1#lrd=0x89c259352c0429df:0x3873abc8e24ab56d,1,,,,", "_blank")}
                        />
                      </div>
                    </div>
                    <div className="rcs_customer_slide_text_content mb-4">
                      <p>{customdata?.review?.slice(0, 150)}{customdata?.review?.length > 150 ? "..." : ""}</p>
                      <Link to="#" onClick={() => window.open("https://www.google.com/search?sca_esv=e45feeb30c95b33e&q=Eli+David+Designs&ludocid=4067783767724045677&lsig=AB86z5WmpIlGOup3PfemKu7soR6i&sa=X&ved=2ahUKEwjpzZqf6cqMAxURja8BHf5BKqUQoAJ6BAghEBo&biw=1745&bih=828&dpr=1.1#lrd=0x89c259352c0429df:0x3873abc8e24ab56d,1,,,,", "_blank")}>
                        Read More
                      </Link>
                    </div>
                    <div className="rcs_customer_review_footer d-flex align-items-center">
                      <div className="name-charAt mr-3">{customdata?.username?.charAt(0)}</div>
                      <div className="rcs_customer_review_slide_title">
                        <h3>{customdata?.username}</h3>
                        <Rating name="half-rating-read" value={customdata?.rating || 5} precision={0.5} size="medium" readOnly />
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
        </Row>

        {isMobile && (
          <div className="rcs_customer_review_btn text-center mt-5">
            <Button className="btn outline-base-btn large" onClick={() => window.open("https://www.google.com/search?sca_esv=e45feeb30c95b33e&q=Eli+David+Designs&ludocid=4067783767724045677&lsig=AB86z5WmpIlGOup3PfemKu7soR6i&sa=X&ved=2ahUKEwjpzZqf6cqMAxURja8BHf5BKqUQoAJ6BAghEBo&biw=1745&bih=828&dpr=1.1#lrd=0x89c259352c0429df:0x3873abc8e24ab56d,1,,,,", "_blank")}>
              Write a Review
            </Button>
          </div>
        )}
      </Container>
    </section>
  );
};

export default Customer;
